import React, { useEffect, useRef, useState } from "react";
import styles from "../ContentBlocks.module.css";
import { useDeviceClassification } from "utils";
import classNames from "classnames";
import { SimpleSplitImageTextCarouselBlock } from "./SimpleSplitImageTextCarouselBlock";
import { useIntersectionObserver } from 'usehooks-ts'

export const SplitImageTextCarouselBlockModel = ({ ...props }) => {

  const { isDesktop } = useDeviceClassification();
  const ref = useRef<HTMLDivElement | null>(null);
  const entry = useIntersectionObserver(ref, { rootMargin: '0px 0px 30% 0px' , root: null, });
  const isVisible = entry?.isIntersecting;
  const [autoPlay, setAutoPlay] = useState(false);

  useEffect(() => {
    setAutoPlay(isVisible);
  }, [isVisible])

  // UI Config
  const showCaptions = props.ShowCaptions !== null || props.ShowCaptions !== undefined ? props.ShowCaptions : true;
  const bgColor = props.BackgroundColour?.Value || 'transparent';
  const BlockContentOrientation = props.BlockContentOrientation?.Name ? props.BlockContentOrientation.Name : "Text Right and Carousel Left";
  const Description = props.Description
    ? props.Description
    : "No Description Provided";

  // Images
  const Images = props.CarouselBlockImagePool.map((img) => ({
    Alt: img.Alt,
    Src: img.Src,
  }));

  const determineSlideType = () => {
    return BlockContentOrientation === "Text Right and Carousel Left" ?
      'slide-in-from-left'
      :
      'slide-in-from-right'
  };

  return (
    <div ref={ref}
      className={classNames(styles.SplitImageTextCarouselBlockWrapper, "slide-up")}
      style={{ width: '100vw' }}>
      <SimpleSplitImageTextCarouselBlock
        determineSlideType={determineSlideType()}
        interval={parseInt(props.Duration ? props.Duration + "000" : null)}
        autoPlay={autoPlay}
        showCaptions={showCaptions}
        mobile={!isDesktop}
        bgColor={bgColor}
        BlockContentOrientation={BlockContentOrientation}
        Images={Images}
        HeadingSuperscript={props.HeadingSuperscript}
        HeadingLarge={props.HeadingLarge}
        Description={Description}
      />

    </div>
  );
};
